let envVars = {};

export function setupEnv(vars) {
    envVars = vars;
}

export default function(key) {
    const useEnv = process.env.REACT_APP_USE_BROWSER_ENV === 'true';
    return useEnv ? window[key] || envVars[key] : envVars[key];
}